<template>
<span class="textarea-load">
            <!-- :placeholder="textareaPlaceholder" -->
    <label :for="labelKeys" :class="{'focus-lable-value': isShowStyle, 'focus-lable' : isShowStyleValue}"><span v-if="isRequire" style="color: red;">* </span>{{hiddenLabel ? "" : textareaPlaceholder}}</label>
        <el-input
            :resize="resize"
            autosize
            type="textarea"
            :class="{'pickNotes': isShowStyle}"
            :maxlength="maxLength"
            v-bind="$attrs"
            v-on="$listeners"
            :id="labelKeys"
            @focus="textFocus"
            @blur="textBlur"
        >
        </el-input>
        <!-- <div :resize="resize"
            v-else
            autosize
            ref="inputDiv"
            :class="{'pickNotes': isShowStyle, 'el-input__inner': true, 'input-div': true}"
            :maxlength="maxLength"
            v-bind="$attrs"
            v-on="$listeners"
            :id="labelKeys"
            @focus="textFocus"
            :style="{'height': textareaHeight + 'px'}"
            @blur="textBlur" :contenteditable="true"> 
            <slot name="valueInput"></slot>
        </div> -->
</span>
 
</template>

<script>
export default {
    props:{
        valueInput: {
            type: String,
            default: ''
        },
        isDiv: {
            type: Boolean,
            default: true
        },
        textareaPlaceholder: {
            type: String,
            default: () => "Site Instruction",
        },
        textareaHeight: {
            type: Number,
            default: () => 60
        },
        labelKeys: {
            type: String,
            default: () => "Notes",
        },
        resize: {
            type: String,
            default: () => "none",
        },
        isRequire: {
            type: Boolean,
            default: false,
        },
        maxLength: {
            type: String,
            default: () => "1000",
        },
        hiddenLabel: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        $attrs: {
            handler(value) {
                if(value.value) {
                    this.isShowStyleValue = true
                }else {
                    this.isShowStyle = false
                    this.isShowStyleValue = false
                }
            },
            immediate: true,
            deep: true,
        }
    },
    data() {
        return {
            isShowStyle: false,
            isShowStyleValue: false
        }
    },
    
    methods: {
        ruleA() {

        },
        textFocus() {
            this.isShowStyle = true
        },
        textBlur(el) {
            // if (!this.isDiv) {
            //     let html = el.target.innerHTML
            //     if (el.target.innerText &&
            //         el.target.innerText.length == 1 && 
            //         el.target.innerText[0].charCodeAt() == 10) html = ''
            //     if(html) {
            //         this.isShowStyleValue = true
            //         this.isShowStyle = false
            //     }else {
            //         this.isShowStyle = false
            //         this.isShowStyleValue = false
            //     }
            //     this.$emit('getMessage', html)
            // } else {
                if(el.target.value) {
                    this.isShowStyleValue = true
                    this.isShowStyle = false
                }else {
                    this.isShowStyle = false
                    this.isShowStyleValue = false
                }
            // }
            
        },
       
    },
    mounted() {
        // if(!this.isDiv) {
        //     console.log(this.$refs.inputDiv)
        //     this.textBlur({target: this.$refs.inputDiv})
        // }
    }

}
</script>

<style scoped lang="scss">

.textarea-load {
    width: 100%;
    height: auto;
    display: inline-block;
    .input-div div{
        height: auto !important;
    }
    /deep/ div {
        height: 100%;
    }
  /deep/ {
    textarea::placeholder{
      font-weight: 400;
    }
  }
    /deep/ .el-textarea__inner{
        min-height: 72px !important;
        input {
            height: 100%;
        }
    }
}
.input-div{
    height: 100%;
    overflow-y: auto;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 6px;
    // height: 100% !important;
}
.textarea-load {
    position: relative;
    height: 100%;
    label {
        z-index: 999;
        left: 10px;
        top: 7px;
        pointer-events: none;
        font-size: 12px !important;
        color: #7f8596;
        font-weight: 500;
        position: absolute;
        transform: translateY(10%) !important;
        transition: all 200ms ease !important;
        background: #fff;
    }
    .focus-lable {
        left: 15px;
        transform: translateY(-100%) !important; 
        transition: all 200ms ease !important;
    }
    .focus-lable-value {
        color: #4066d4;
        left: 15px;
        transform: translateY(-100%) !important; 
        transition: all 200ms ease !important;
    }
}
/deep/ .el-textarea__inner {
    font-size: 12px !important;
    color: #000c2e !important;
    font-family: OpenSans !important;
    font-size: 14px !important;
    font-weight: 600 !important;
}
/deep/ .el-input__inner {
    font-size: 12px !important;
    color: #000c2e !important;
    font-family: OpenSans !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    height: 60px;
    // padding-bottom: 20px;
    &:focus {
        box-shadow: 0 0 0 2px #c6d1f2;
        outline: 0;
    }
}
/deep/ .el-textarea__inner {
    &:focus {
        box-shadow: 0 0 0 2px #c6d1f2;
        outline: 0;
    }
}
// .pickNotes::after {
//   content: '';
//   position: absolute;
//   top: -2px;
//   left: -2px;
//   width: calc(100% + 4px);
//   height: calc(100% + 4px);
//   border: 2px solid #c6d1f2;
//   border-radius: 6px;
// }
</style>
